import { DictationEventType } from "@tt-app/models/exercise/dictation";

type DictationEventKey =
  | "BOT_AUDIO_AUTOPLAY"
  | "USER_AUDIO_AUTOPLAY"
  | "BOT_AUDIO_CLICK_TO_PLAY"
  | "USER_AUDIO_CLICK_TO_PLAY"
  | "TILE_CLICK_OPTIONS"
  | "TILE_CLICK_DISPLAY"
  | "ANSWER_SUBMITTED"
  | "IMAGE_OPENED"
  | "IMAGE_CLOSED";

export const DICTATION_EVENT: { [key in DictationEventKey]: DictationEventType } = {
  BOT_AUDIO_AUTOPLAY: 0,
  USER_AUDIO_AUTOPLAY: 1,
  BOT_AUDIO_CLICK_TO_PLAY: 2,
  USER_AUDIO_CLICK_TO_PLAY: 3,
  TILE_CLICK_OPTIONS: 4,
  TILE_CLICK_DISPLAY: 5,
  ANSWER_SUBMITTED: 6,
  IMAGE_OPENED: 7,
  IMAGE_CLOSED: 8
};
